import { AfterViewInit, Component, input, Input } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { SubstitutionPipe } from '../../substitution.pipe';
import { ContextService } from '../../context.service';

@Component({
  selector: 'mutara-alert',
  templateUrl: './alert.component.html',
  styles: ['.mat-icon { margin-top: 0.3em;}'],
  standalone: false
})
export class AlertComponent extends FieldType implements AfterViewInit {
  protected label : string = '';
  protected description : string = '';
  protected secondaryText : string = '';

  private subs: SubstitutionPipe;

  constructor(public context: ContextService) {
    super();
    this.subs = new SubstitutionPipe(this.context);
  }
  ngAfterViewInit(): void {
    this.label = <string>this.props.label;
    this.context.subscribeTo('applicationNumber', () => {
      this.resetText();
    });
  }
  resetText() {
    this.label = this.subs.transform(this.props.label);
    this.description = this.subs.transform(this.props.description);
    this.secondaryText = this.subs.transform(this.props.secondaryText);
  }
}
